import React from 'react'
// react component for creating dynamic tables
import ReactTable from 'react-table'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment'
import DeleteForever from '@material-ui/icons/DeleteForever'
import ZoomIn from '@material-ui/icons/ZoomIn'

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import Button from 'components/CustomButtons/Button.jsx'

// general api
import { deleteRecord } from '../../services/generalServiceAPI'

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  updateProfileButton: {
    float: 'right'
  },
  icon: {
    fontSize: 96 // why this isn't working
    // border: '1px solid'
  }
}

class UserGroupAllTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: {}
    }
  }

  render() {
    const { classes, showEditProfile, userGroups } = this.props
    let displayData = []
    displayData = userGroups.map((c, k) => {
      return {
        ...c,
        actions: (
          <div>
            <Button
              justIcon
              round
              simple
              onClick={e => {
                showEditProfile(c)
              }}
              color="primary"
            >
              <ZoomIn className={classes.icon} />
            </Button>
            <Button
              justIcon
              round
              simple
              onClick={async () => {
                await deleteRecord({
                  tableName: 'userGroups',
                  id: c.id,
                  refetch: this.props.refetch
                })
                if (this.props.hideEditProfile) this.props.hideEditProfile()
              }}
              color="danger"
            >
              <DeleteForever className={classes.icon} />
            </Button>
          </div>
        )
      }
    })
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>User Groups </h4>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={displayData}
                  filterable
                  columns={[
                    {
                      Header: 'UserGroup Name',
                      accessor: 'name',
                      width: 200,
                      filterable: false
                    },
                    {
                      Header: 'Details',
                      accessor: 'description',
                      minWidth: 400,
                      maxWidth: 600,
                      filterable: false
                    },
                    {
                      Header: 'Actions',
                      accessor: 'actions',
                      width: 100,
                      filterable: false,
                      style: {
                        align: 'center'
                      }
                    },
                    {
                      //fix alignment bug
                      width: 0,
                      filterable: false
                    }
                  ]}
                  // getTrProps={(state, rowInfo) => {
                  //   return {
                  //     onClick: e => {
                  //       console.log(e.target.type)
                  //       if (e.target.type != 'button') {
                  //         let { __typename, actions, ...rest } = rowInfo.original
                  //         showEditProfile(rest)
                  //       }
                  //     }
                  //   }
                  // }}
                  defaultPageSize={5}
                  //minRow={3}
                  //headClassname=""
                  showPaginationTop={false}
                  showPaginationBottom={true} //={true} //can be ignored
                  className="-striped -highlight"
                />
                <Button
                  color="rose"
                  className={classes.updateProfileButton}
                  onClick={() => {
                    showEditProfile({ id: '', name: '', description: '' })
                  }}
                >
                  Create new userGroup
                </Button>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(styles)(UserGroupAllTable)
